@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_102_086_943)
internal val Res.drawable.sugar: DrawableResource by lazy {
      DrawableResource("drawable:sugar", setOf(
        ResourceItem(setOf(), "${MD}drawable/sugar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_807_607_228)
internal val Res.drawable.sugar_cane: DrawableResource by lazy {
      DrawableResource("drawable:sugar_cane", setOf(
        ResourceItem(setOf(), "${MD}drawable/sugar_cane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_472_553_239)
internal val Res.drawable.sunflower: DrawableResource by lazy {
      DrawableResource("drawable:sunflower", setOf(
        ResourceItem(setOf(), "${MD}drawable/sunflower.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-81_133_138)
internal val Res.drawable.surface_blind_potion: DrawableResource by lazy {
      DrawableResource("drawable:surface_blind_potion", setOf(
        ResourceItem(setOf(), "${MD}drawable/surface_blind_potion.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(244_645_082)
internal val Res.drawable.suspicious_stew: DrawableResource by lazy {
      DrawableResource("drawable:suspicious_stew", setOf(
        ResourceItem(setOf(), "${MD}drawable/suspicious_stew.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(931_938_192)
internal val Res.drawable.sweet_berries: DrawableResource by lazy {
      DrawableResource("drawable:sweet_berries", setOf(
        ResourceItem(setOf(), "${MD}drawable/sweet_berries.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(864_036_926)
internal val Res.drawable.tall_grass: DrawableResource by lazy {
      DrawableResource("drawable:tall_grass", setOf(
        ResourceItem(setOf(), "${MD}drawable/tall_grass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_047_796_438)
internal val Res.drawable.target: DrawableResource by lazy {
      DrawableResource("drawable:target", setOf(
        ResourceItem(setOf(), "${MD}drawable/target.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(973_226_124)
internal val Res.drawable.terracotta: DrawableResource by lazy {
      DrawableResource("drawable:terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_303_654_009)
internal val Res.drawable.tipped_arrow: DrawableResource by lazy {
      DrawableResource("drawable:tipped_arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/tipped_arrow.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_258_789_010)
internal val Res.drawable.tnt: DrawableResource by lazy {
      DrawableResource("drawable:tnt", setOf(
        ResourceItem(setOf(), "${MD}drawable/tnt.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_030_004_151)
internal val Res.drawable.tnt_minecart: DrawableResource by lazy {
      DrawableResource("drawable:tnt_minecart", setOf(
        ResourceItem(setOf(), "${MD}drawable/tnt_minecart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-173_478_440)
internal val Res.drawable.torch: DrawableResource by lazy {
      DrawableResource("drawable:torch", setOf(
        ResourceItem(setOf(), "${MD}drawable/torch.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-682_490_965)
internal val Res.drawable.totem_of_undying: DrawableResource by lazy {
      DrawableResource("drawable:totem_of_undying", setOf(
        ResourceItem(setOf(), "${MD}drawable/totem_of_undying.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-150_311_085)
internal val Res.drawable.trader_llama_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:trader_llama_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/trader_llama_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_785_379_686)
internal val Res.drawable.trapped_chest: DrawableResource by lazy {
      DrawableResource("drawable:trapped_chest", setOf(
        ResourceItem(setOf(), "${MD}drawable/trapped_chest.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_026_415_758)
internal val Res.drawable.trident: DrawableResource by lazy {
      DrawableResource("drawable:trident", setOf(
        ResourceItem(setOf(), "${MD}drawable/trident.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(144_455_966)
internal val Res.drawable.tripwire_hook: DrawableResource by lazy {
      DrawableResource("drawable:tripwire_hook", setOf(
        ResourceItem(setOf(), "${MD}drawable/tripwire_hook.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_990_058_001)
internal val Res.drawable.tropical_fish: DrawableResource by lazy {
      DrawableResource("drawable:tropical_fish", setOf(
        ResourceItem(setOf(), "${MD}drawable/tropical_fish.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_068_945_399)
internal val Res.drawable.tropical_fish_bucket: DrawableResource by lazy {
      DrawableResource("drawable:tropical_fish_bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/tropical_fish_bucket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(422_822_295)
internal val Res.drawable.tropical_fish_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:tropical_fish_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/tropical_fish_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_140_944_681)
internal val Res.drawable.tube_coral: DrawableResource by lazy {
      DrawableResource("drawable:tube_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/tube_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(91_518_028)
internal val Res.drawable.tube_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:tube_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/tube_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(905_593_907)
internal val Res.drawable.tube_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:tube_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/tube_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_521_515_509)
internal val Res.drawable.turtle_egg: DrawableResource by lazy {
      DrawableResource("drawable:turtle_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/turtle_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_860_352_079)
internal val Res.drawable.turtle_helmet: DrawableResource by lazy {
      DrawableResource("drawable:turtle_helmet", setOf(
        ResourceItem(setOf(), "${MD}drawable/turtle_helmet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_147_300_854)
internal val Res.drawable.turtle_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:turtle_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/turtle_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_781_789_387)
internal val Res.drawable.twisting_vines: DrawableResource by lazy {
      DrawableResource("drawable:twisting_vines", setOf(
        ResourceItem(setOf(), "${MD}drawable/twisting_vines.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(235_824_552)
internal val Res.drawable.vex_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:vex_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/vex_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_019_795_939)
internal val Res.drawable.villager_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:villager_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/villager_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_490_388_334)
internal val Res.drawable.vindicator_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:vindicator_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/vindicator_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-864_047_029)
internal val Res.drawable.vine: DrawableResource by lazy {
      DrawableResource("drawable:vine", setOf(
        ResourceItem(setOf(), "${MD}drawable/vine.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(498_814_364)
internal val Res.drawable.wandering_trader_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:wandering_trader_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/wandering_trader_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-657_334_433)
internal val Res.drawable.warped_button: DrawableResource by lazy {
      DrawableResource("drawable:warped_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_040_650_537)
internal val Res.drawable.warped_door: DrawableResource by lazy {
      DrawableResource("drawable:warped_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_065_602_933)
internal val Res.drawable.warped_fence: DrawableResource by lazy {
      DrawableResource("drawable:warped_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_211_243_205)
internal val Res.drawable.warped_fence_gate: DrawableResource by lazy {
      DrawableResource("drawable:warped_fence_gate", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_fence_gate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(795_296_886)
internal val Res.drawable.warped_fungus: DrawableResource by lazy {
      DrawableResource("drawable:warped_fungus", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_fungus.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_272_073_886)
internal val Res.drawable.warped_fungus_on_a_stick: DrawableResource by lazy {
      DrawableResource("drawable:warped_fungus_on_a_stick", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_fungus_on_a_stick.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-438_367_119)
internal val Res.drawable.warped_hyphae: DrawableResource by lazy {
      DrawableResource("drawable:warped_hyphae", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_hyphae.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_174_522_485)
internal val Res.drawable.warped_nylium: DrawableResource by lazy {
      DrawableResource("drawable:warped_nylium", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_nylium.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(291_194_021)
internal val Res.drawable.warped_planks: DrawableResource by lazy {
      DrawableResource("drawable:warped_planks", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_planks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_641_132_143)
internal val Res.drawable.warped_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:warped_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_084_349_252)
internal val Res.drawable.warped_roots: DrawableResource by lazy {
      DrawableResource("drawable:warped_roots", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_roots.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_165_181_167)
internal val Res.drawable.warped_sign: DrawableResource by lazy {
      DrawableResource("drawable:warped_sign", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_sign.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_356_921_946)
internal val Res.drawable.warped_slab: DrawableResource by lazy {
      DrawableResource("drawable:warped_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-137_795_378)
internal val Res.drawable.warped_stairs: DrawableResource by lazy {
      DrawableResource("drawable:warped_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(626_656_725)
internal val Res.drawable.warped_stem: DrawableResource by lazy {
      DrawableResource("drawable:warped_stem", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_stem.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_087_417_887)
internal val Res.drawable.warped_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:warped_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_905_044_775)
internal val Res.drawable.warped_wart_block: DrawableResource by lazy {
      DrawableResource("drawable:warped_wart_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/warped_wart_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-722_370_421)
internal val Res.drawable.water_bucket: DrawableResource by lazy {
      DrawableResource("drawable:water_bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/water_bucket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_028_633_163)
internal val Res.drawable.weeping_vines: DrawableResource by lazy {
      DrawableResource("drawable:weeping_vines", setOf(
        ResourceItem(setOf(), "${MD}drawable/weeping_vines.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-954_629_206)
internal val Res.drawable.wet_sponge: DrawableResource by lazy {
      DrawableResource("drawable:wet_sponge", setOf(
        ResourceItem(setOf(), "${MD}drawable/wet_sponge.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_010_771_520)
internal val Res.drawable.wheat: DrawableResource by lazy {
      DrawableResource("drawable:wheat", setOf(
        ResourceItem(setOf(), "${MD}drawable/wheat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_201_595_588)
internal val Res.drawable.wheat_seeds: DrawableResource by lazy {
      DrawableResource("drawable:wheat_seeds", setOf(
        ResourceItem(setOf(), "${MD}drawable/wheat_seeds.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_677_679)
internal val Res.drawable.white_banner: DrawableResource by lazy {
      DrawableResource("drawable:white_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-459_117_179)
internal val Res.drawable.white_bed: DrawableResource by lazy {
      DrawableResource("drawable:white_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-252_320_878)
internal val Res.drawable.white_carpet: DrawableResource by lazy {
      DrawableResource("drawable:white_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_579_340_495)
internal val Res.drawable.white_concrete: DrawableResource by lazy {
      DrawableResource("drawable:white_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-331_213_163)
internal val Res.drawable.white_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:white_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(109_358_772)
internal val Res.drawable.white_dye: DrawableResource by lazy {
      DrawableResource("drawable:white_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_132_220_993)
internal val Res.drawable.white_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:white_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-261_562_099)
internal val Res.drawable.white_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:white_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(802_454_262)
internal val Res.drawable.white_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:white_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(416_718_249)
internal val Res.drawable.white_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:white_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(946_318_676)
internal val Res.drawable.white_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:white_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-851_530_932)
internal val Res.drawable.white_tulip: DrawableResource by lazy {
      DrawableResource("drawable:white_tulip", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_tulip.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-548_010_564)
internal val Res.drawable.white_wool: DrawableResource by lazy {
      DrawableResource("drawable:white_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/white_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_994_932_728)
internal val Res.drawable.witch_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:witch_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/witch_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-201_495_842)
internal val Res.drawable.wither_rose: DrawableResource by lazy {
      DrawableResource("drawable:wither_rose", setOf(
        ResourceItem(setOf(), "${MD}drawable/wither_rose.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_360_037_626)
internal val Res.drawable.wither_skeleton_skull: DrawableResource by lazy {
      DrawableResource("drawable:wither_skeleton_skull", setOf(
        ResourceItem(setOf(), "${MD}drawable/wither_skeleton_skull.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_308_441_977)
internal val Res.drawable.wither_skeleton_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:wither_skeleton_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/wither_skeleton_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_883_434_079)
internal val Res.drawable.wolf_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:wolf_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/wolf_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-486_537_519)
internal val Res.drawable.wooden_axe: DrawableResource by lazy {
      DrawableResource("drawable:wooden_axe", setOf(
        ResourceItem(setOf(), "${MD}drawable/wooden_axe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_870_459_776)
internal val Res.drawable.wooden_hoe: DrawableResource by lazy {
      DrawableResource("drawable:wooden_hoe", setOf(
        ResourceItem(setOf(), "${MD}drawable/wooden_hoe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(984_156_560)
internal val Res.drawable.wooden_pickaxe: DrawableResource by lazy {
      DrawableResource("drawable:wooden_pickaxe", setOf(
        ResourceItem(setOf(), "${MD}drawable/wooden_pickaxe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-430_682_185)
internal val Res.drawable.wooden_shovel: DrawableResource by lazy {
      DrawableResource("drawable:wooden_shovel", setOf(
        ResourceItem(setOf(), "${MD}drawable/wooden_shovel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_098_067_098)
internal val Res.drawable.wooden_sword: DrawableResource by lazy {
      DrawableResource("drawable:wooden_sword", setOf(
        ResourceItem(setOf(), "${MD}drawable/wooden_sword.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_959_825_867)
internal val Res.drawable.writable_book: DrawableResource by lazy {
      DrawableResource("drawable:writable_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/writable_book.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-770_337_322)
internal val Res.drawable.written_book: DrawableResource by lazy {
      DrawableResource("drawable:written_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/written_book.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_970_339_893)
internal val Res.drawable.yellow_banner: DrawableResource by lazy {
      DrawableResource("drawable:yellow_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-987_692_065)
internal val Res.drawable.yellow_bed: DrawableResource by lazy {
      DrawableResource("drawable:yellow_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(64_671_475)
internal val Res.drawable.yellow_carpet: DrawableResource by lazy {
      DrawableResource("drawable:yellow_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_555_340_728)
internal val Res.drawable.yellow_concrete: DrawableResource by lazy {
      DrawableResource("drawable:yellow_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(201_856_654)
internal val Res.drawable.yellow_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:yellow_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(924_916_173)
internal val Res.drawable.yellow_dye: DrawableResource by lazy {
      DrawableResource("drawable:yellow_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_101_859_099)
internal val Res.drawable.yellow_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:yellow_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(595_399_881)
internal val Res.drawable.yellow_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:yellow_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_300_432_034)
internal val Res.drawable.yellow_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:yellow_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-261_161_328)
internal val Res.drawable.yellow_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:yellow_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(892_029_161)
internal val Res.drawable.yellow_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:yellow_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_047_772_269)
internal val Res.drawable.yellow_wool: DrawableResource by lazy {
      DrawableResource("drawable:yellow_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/yellow_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_134_603_389)
internal val Res.drawable.zoglin_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:zoglin_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/zoglin_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_513_378_206)
internal val Res.drawable.zombie_head: DrawableResource by lazy {
      DrawableResource("drawable:zombie_head", setOf(
        ResourceItem(setOf(), "${MD}drawable/zombie_head.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-599_993_845)
internal val Res.drawable.zombie_horse_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:zombie_horse_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/zombie_horse_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(284_290_875)
internal val Res.drawable.zombie_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:zombie_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/zombie_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(764_843_111)
internal val Res.drawable.zombie_villager_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:zombie_villager_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/zombie_villager_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_616_001_658)
internal val Res.drawable.zombified_piglin_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:zombified_piglin_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/zombified_piglin_spawn_egg.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable9Resources(map: MutableMap<String, DrawableResource>) {
  map.put("sugar", Res.drawable.sugar)
  map.put("sugar_cane", Res.drawable.sugar_cane)
  map.put("sunflower", Res.drawable.sunflower)
  map.put("surface_blind_potion", Res.drawable.surface_blind_potion)
  map.put("suspicious_stew", Res.drawable.suspicious_stew)
  map.put("sweet_berries", Res.drawable.sweet_berries)
  map.put("tall_grass", Res.drawable.tall_grass)
  map.put("target", Res.drawable.target)
  map.put("terracotta", Res.drawable.terracotta)
  map.put("tipped_arrow", Res.drawable.tipped_arrow)
  map.put("tnt", Res.drawable.tnt)
  map.put("tnt_minecart", Res.drawable.tnt_minecart)
  map.put("torch", Res.drawable.torch)
  map.put("totem_of_undying", Res.drawable.totem_of_undying)
  map.put("trader_llama_spawn_egg", Res.drawable.trader_llama_spawn_egg)
  map.put("trapped_chest", Res.drawable.trapped_chest)
  map.put("trident", Res.drawable.trident)
  map.put("tripwire_hook", Res.drawable.tripwire_hook)
  map.put("tropical_fish", Res.drawable.tropical_fish)
  map.put("tropical_fish_bucket", Res.drawable.tropical_fish_bucket)
  map.put("tropical_fish_spawn_egg", Res.drawable.tropical_fish_spawn_egg)
  map.put("tube_coral", Res.drawable.tube_coral)
  map.put("tube_coral_block", Res.drawable.tube_coral_block)
  map.put("tube_coral_fan", Res.drawable.tube_coral_fan)
  map.put("turtle_egg", Res.drawable.turtle_egg)
  map.put("turtle_helmet", Res.drawable.turtle_helmet)
  map.put("turtle_spawn_egg", Res.drawable.turtle_spawn_egg)
  map.put("twisting_vines", Res.drawable.twisting_vines)
  map.put("vex_spawn_egg", Res.drawable.vex_spawn_egg)
  map.put("villager_spawn_egg", Res.drawable.villager_spawn_egg)
  map.put("vindicator_spawn_egg", Res.drawable.vindicator_spawn_egg)
  map.put("vine", Res.drawable.vine)
  map.put("wandering_trader_spawn_egg", Res.drawable.wandering_trader_spawn_egg)
  map.put("warped_button", Res.drawable.warped_button)
  map.put("warped_door", Res.drawable.warped_door)
  map.put("warped_fence", Res.drawable.warped_fence)
  map.put("warped_fence_gate", Res.drawable.warped_fence_gate)
  map.put("warped_fungus", Res.drawable.warped_fungus)
  map.put("warped_fungus_on_a_stick", Res.drawable.warped_fungus_on_a_stick)
  map.put("warped_hyphae", Res.drawable.warped_hyphae)
  map.put("warped_nylium", Res.drawable.warped_nylium)
  map.put("warped_planks", Res.drawable.warped_planks)
  map.put("warped_pressure_plate", Res.drawable.warped_pressure_plate)
  map.put("warped_roots", Res.drawable.warped_roots)
  map.put("warped_sign", Res.drawable.warped_sign)
  map.put("warped_slab", Res.drawable.warped_slab)
  map.put("warped_stairs", Res.drawable.warped_stairs)
  map.put("warped_stem", Res.drawable.warped_stem)
  map.put("warped_trapdoor", Res.drawable.warped_trapdoor)
  map.put("warped_wart_block", Res.drawable.warped_wart_block)
  map.put("water_bucket", Res.drawable.water_bucket)
  map.put("weeping_vines", Res.drawable.weeping_vines)
  map.put("wet_sponge", Res.drawable.wet_sponge)
  map.put("wheat", Res.drawable.wheat)
  map.put("wheat_seeds", Res.drawable.wheat_seeds)
  map.put("white_banner", Res.drawable.white_banner)
  map.put("white_bed", Res.drawable.white_bed)
  map.put("white_carpet", Res.drawable.white_carpet)
  map.put("white_concrete", Res.drawable.white_concrete)
  map.put("white_concrete_powder", Res.drawable.white_concrete_powder)
  map.put("white_dye", Res.drawable.white_dye)
  map.put("white_glazed_terracotta", Res.drawable.white_glazed_terracotta)
  map.put("white_shulker_box", Res.drawable.white_shulker_box)
  map.put("white_stained_glass", Res.drawable.white_stained_glass)
  map.put("white_stained_glass_pane", Res.drawable.white_stained_glass_pane)
  map.put("white_terracotta", Res.drawable.white_terracotta)
  map.put("white_tulip", Res.drawable.white_tulip)
  map.put("white_wool", Res.drawable.white_wool)
  map.put("witch_spawn_egg", Res.drawable.witch_spawn_egg)
  map.put("wither_rose", Res.drawable.wither_rose)
  map.put("wither_skeleton_skull", Res.drawable.wither_skeleton_skull)
  map.put("wither_skeleton_spawn_egg", Res.drawable.wither_skeleton_spawn_egg)
  map.put("wolf_spawn_egg", Res.drawable.wolf_spawn_egg)
  map.put("wooden_axe", Res.drawable.wooden_axe)
  map.put("wooden_hoe", Res.drawable.wooden_hoe)
  map.put("wooden_pickaxe", Res.drawable.wooden_pickaxe)
  map.put("wooden_shovel", Res.drawable.wooden_shovel)
  map.put("wooden_sword", Res.drawable.wooden_sword)
  map.put("writable_book", Res.drawable.writable_book)
  map.put("written_book", Res.drawable.written_book)
  map.put("yellow_banner", Res.drawable.yellow_banner)
  map.put("yellow_bed", Res.drawable.yellow_bed)
  map.put("yellow_carpet", Res.drawable.yellow_carpet)
  map.put("yellow_concrete", Res.drawable.yellow_concrete)
  map.put("yellow_concrete_powder", Res.drawable.yellow_concrete_powder)
  map.put("yellow_dye", Res.drawable.yellow_dye)
  map.put("yellow_glazed_terracotta", Res.drawable.yellow_glazed_terracotta)
  map.put("yellow_shulker_box", Res.drawable.yellow_shulker_box)
  map.put("yellow_stained_glass", Res.drawable.yellow_stained_glass)
  map.put("yellow_stained_glass_pane", Res.drawable.yellow_stained_glass_pane)
  map.put("yellow_terracotta", Res.drawable.yellow_terracotta)
  map.put("yellow_wool", Res.drawable.yellow_wool)
  map.put("zoglin_spawn_egg", Res.drawable.zoglin_spawn_egg)
  map.put("zombie_head", Res.drawable.zombie_head)
  map.put("zombie_horse_spawn_egg", Res.drawable.zombie_horse_spawn_egg)
  map.put("zombie_spawn_egg", Res.drawable.zombie_spawn_egg)
  map.put("zombie_villager_spawn_egg", Res.drawable.zombie_villager_spawn_egg)
  map.put("zombified_piglin_spawn_egg", Res.drawable.zombified_piglin_spawn_egg)
}
